module.exports = __webpack_public_path__ + "static/media/marketplace.84c6d3e3.svg";